module.exports = __webpack_public_path__ + "img/rule-detail-title.d90d5e77.png";